export function baseClass(baseClassName, addClasses) {
  return baseClassName + (addClasses ? (" " + addClasses) : "");
}